import { render, staticRenderFns } from "./UsersOnTtaPage.vue?vue&type=template&id=4ece196b&"
import script from "./UsersOnTtaPage.vue?vue&type=script&lang=js&"
export * from "./UsersOnTtaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports